export const forgivenessTileListSelector = ({ config, entities }) => ({
  advances: entities.advances,
  opportunities: entities.opportunities,
  portalRedesignEnabled: config.portalRedesignEnabled,
  ppp21LoFoEnabled: config.ppp21LoFoEnabled,
});
